module.exports = __webpack_public_path__ + "static/img/game-img-yybs.e82d13f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/game-img-yybs.png
// module id = SDs/
// module chunks = 0